export enum PhoneNumberUsageStatus {
  NOT_USED = 'NOT_USED',
  USED_WITHOUT_COUPON = 'USED_WITHOUT_COUPON',
  USED_WITH_COUPON = 'USED_WITH_COUPON',
}
